export default __webpack_public_path__ + "static/media/logo_text.eee3daf3.png";